export default selector => document.querySelector(selector);



/** WEBPACK FOOTER **
 ** ./app/scripts/util/dom/qs.js
 **/